import { IFacetGroupFilter } from 'Types/Litium';
import ArrowDownIcon from 'Icons/caretGsd.svg?react';
import React, { useState, useRef, useEffect } from 'react';
import useOutsideClick from 'Hooks/useOutsideClick';
import FacetGroupFilter from 'Pages/ProductListingPage/FacetGroupFilter';
import getFiltrationValuesAndUpdateUrlQuery from 'Utils/getFiltrationValuesAndUpdateUrlQuery';

type IFilterProps = {
    getFiltration: (
        param: {
            name: string;
            value: string;
        }[]
    ) => void;
    isFetching: boolean;
    className?: string;
    facetFilters: IFacetGroupFilter[];
};

const Filter = ({
    className = '',
    facetFilters,
    getFiltration,
    isFetching,
}: IFilterProps) => {
    const [openFilter, setOpenFilter] = useState(-1);
    const filterRef = useRef<HTMLFormElement>();
    const handleFocusTrapForFacetGroupFilter = (
        event: React.KeyboardEvent<HTMLButtonElement>
    ) => {
        if (event.key === 'Tab') {
            if (event.shiftKey) {
                setOpenFilter(-1);
            }
        }
    };

    const handleClickOutside = () => {
        setOpenFilter(-1);
    };
    useEffect(() => {
        if (openFilter === -1) {
            outsideRef.current = null;
        }
    }, [openFilter]);

    const buttonRef = useRef();
    const outsideRef = useOutsideClick(handleClickOutside, buttonRef);

    const handleFiltration = (
        facetGroups: IFacetGroupFilter[],
        formData: HTMLFormElement
    ) => {
        const data = new FormData(formData);

        const filtrationValues = getFiltrationValuesAndUpdateUrlQuery(
            facetGroups,
            data
        );

        getFiltration(filtrationValues);
    };

    return (
        <form
            ref={filterRef}
            onSubmit={e => e.preventDefault()}
            className={className}
        >
            <ul className="flex items-center gap-12">
                {facetFilters &&
                    facetFilters.map(
                        (filter, index) =>
                            filter.options?.length > 0 && (
                                <li
                                    className="relative flex items-baseline gap-3"
                                    key={index}
                                >
                                    <button
                                        type="button"
                                        ref={
                                            openFilter === index
                                                ? buttonRef
                                                : null
                                        }
                                        className="flex h-8 items-center gap-2 font-montserrat text-sm font-normal text-black"
                                        onClick={() => {
                                            setOpenFilter(
                                                openFilter === index
                                                    ? -1
                                                    : index
                                            );
                                        }}
                                        onKeyDown={event =>
                                            handleFocusTrapForFacetGroupFilter(
                                                event
                                            )
                                        }
                                        aria-controls={`filter-dropdown-${index}`}
                                        aria-expanded={
                                            openFilter === index
                                                ? 'true'
                                                : 'false'
                                        }
                                    >
                                        <span className="font-roboto text-sm font-normal">
                                            {filter.label}
                                            {filter.selectedOptions?.length >
                                                0 && (
                                                <>
                                                    {' '}
                                                    (
                                                    {
                                                        filter.selectedOptions
                                                            .length
                                                    }
                                                    )
                                                </>
                                            )}
                                        </span>
                                        <span>
                                            <ArrowDownIcon
                                                className={`h-3.5 w-3.5 transition-transform ${
                                                    openFilter === index
                                                        ? 'rotate-90'
                                                        : 'rotate-0'
                                                }`}
                                            />
                                        </span>
                                    </button>
                                    <FacetGroupFilter
                                        label={filter.label}
                                        outsideRef={outsideRef}
                                        filterId={`filter-dropdown-${index}`}
                                        showFilter={openFilter === index}
                                        setShowFilter={setOpenFilter}
                                        options={filter.options}
                                        selectedOptions={filter.selectedOptions}
                                        toggleCheckbox={() =>
                                            handleFiltration(
                                                facetFilters,
                                                filterRef.current
                                            )
                                        }
                                        filterGroup={filter.id}
                                        filterIsLoading={isFetching}
                                    />
                                </li>
                            )
                    )}
            </ul>
        </form>
    );
};
export default Filter;
